import { render, staticRenderFns } from "./Invited.vue?vue&type=template&id=56b6ca6e&scoped=true"
import script from "./Invited.vue?vue&type=script&lang=js"
export * from "./Invited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6ca6e",
  null
  
)

export default component.exports